import React from 'react';
import '../template-file-css/document-file-template.css';


export const GENERAL_ServicePlanConsent = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='GENERAL_ServicePlanConsent' className='file-pdf-document'>
            <div className='file-template'>


                <p className='w-750'> I am a:  &nbsp;

                    <input type='checkbox' id='cbClient' name='cbClient' className='add-only ' value='Client' /> Client  &nbsp;
                    <input type='checkbox' id='cbParent' name='cbParent' className='add-only' value='Parent' /> Parent  &nbsp;
                    <input type='checkbox' id='cbGuardian' name='cbGuardian' className='add-only' value='Guardian' /> Guardian.  &nbsp;

                    I know that within the Medicaid guidelines, I have freedom of choice for medical, dental, and case management services as needed. I know that, within the Medicaid guidelines, I have freedom of choice for equipment and supplies as needed. I took part in the making of this service plan. I understand that the referrals in this plan and other referrals deemed necessary by me and my case manager will help put this plan and changes to this plan into effect. I understand referrals will be made on my behalf (or my child's). I understand that information from my needs assessment may be needed to help with referrals. I give my consent for my case manager to share the information as needed to help with referrals. I understand that the information will be shared only with agencies listed in the plan and other referrals deemed necessary by me and my case manager. The information shared will be only what is needed to complete the referral, determine eligibility, or provide services to my child or to me. This consent will expire when the above needs have been met. I understand that I may take back or cancel this consent anytime. To cancel it, I must write to my case manager. I understand that this consent will not affect my (or my child's) treatment, payment, enrollment, or eligibility for benefits. I understand that anyone who gets information as a result of this consent may share it with others as the law allows. I understand that by signing this service plan I am giving my consent and agree to receive case management.
                </p>

                <p className='w-750'> Yo soy un:  &nbsp;

                    <input type='checkbox' id='cbCliente' name='cbCliente' className='add-only ' value='Cliente' /> Cliente  &nbsp;
                    <input type='checkbox' id='cbPadre' name='cbPadre' className='add-only' value='Padre' /> Padre  &nbsp;
                    <input type='checkbox' id='cbTutor' name='cbTutor' className='add-only' value='Tutor' /> Tutor.  &nbsp;

                    Sé que dentro de los reglas de Medicaid, tengo el derecho de elegir los servicios
                    médicos, dental y de administración de casos cuando sea necesario. Sé que dentro de los preceptos de medicaid, tengo la
                    libertad de elegir equipo y suplementos cuando sea necesario. Tomé parte en el desarrollo de este plan de servicio. Entiendo
                    que las referencias en este plan y otras referencias consideradas necesarias por mi y mi administrador(a) de caso me
                    ayudarán poner este plan y cambios de este plan en efecto. Entiendo que las personas indicadas anteriormente ayudarán a
                    que este plan sea efectivo. Entiendo que las referencias serán hechas en mi nombre (o en el de mi hijo). Entiendo que la
                    información de mi evaluación de necesidades puede ser necesaria para ayudar con las referencias en este plan. Doy mi
                    consentimiento a mi administrador(a) de caso para dar la información que sea necesaria a las referencias. Entiendo que la
                    información se le dará únicamente a las agencies citadas en el plan y otras referencias que sean necesarias por mi y mi
                    administrador(a) de casos. La información proporcionada será solamente la que sea necesaria para completar la
                    recomendación, determinar la elegibilidad o dar servicios a mi hijo o a mí. Este consentimiento terminará cuando mis
                    necesidades citadas anteriormente sean satisfechos. Entiendo que puedo revocar o cancelar este consentimiento en
                    cualquier momento. Para cancelarlo, debo escribir a mi administrador(a) de caso. Entiendo que este consentimiento no
                    afectará mi tratamiento (o el de mi hijo), el pago, la inscripción, ni la elegibilidad para beneficios. Entiendo que cualquiera que
                    obtenga información como resultado de este consentimiento podrá compartirla con otras personas de acuerdo a lo permitido
                    por la ley. Entiendo que al firmar este plan de servicios estoy de acuerdo en recibir los servicios de administración de casos.
                </p>

                <table>
                    <tr>
                        <td className='signature w-500'> &nbsp; </td>
                        <td className='signature w-250'> &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> CLIENT/PARENT/GUARDIAN SIGNATURE: <br /> FIRMA DEL CLIENTE/PADRE/TUTOR: </td>
                        <td className='small w-250'> DATE/ FECHA:  </td>
                    </tr>

                    <tr>
                        <td className='signature w-500'> &nbsp; </td>
                        <td className='signature w-250'> &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> CASE MANAGER SIGNATURE: <br /> FIRMA DEL ADMINISTRADOR(A) DEL CASO: </td>
                        <td className='small w-250'> DATE/ FECHA:  </td>
                    </tr>

                    <tr>
                        <td className='signature w-500'> &nbsp; </td>
                        <td className='signature w-250'> &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> CASE MANAGEMENT PROVIDER/AGENCY NAME <br /> NOMBRE DE PROVEEDOR DE ADMINISTRACION DE CASOS: </td>
                        <td className='small w-250'> TELEPHONE/ TELEFONO  </td>
                    </tr>

                    <tr>
                        <td className='signature w-500'> &nbsp; </td>
                        <td className='signature w-250'> &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> NTERPRETER SIGNATURE (IF APPLICABLE)/ <br /> FIRMA DEL INTERPRETE ( SI ES PERTINENTE ) </td>
                        <td className='small w-250'> DATE/ FECHA:  </td>
                    </tr>
                </table>

            </div>
        </form>

    )
}











